import styled from 'styled-components'
import { colors, fieldLabel, fontScope, radius } from '../../../components/SalesReport/tokens'

export const Card = styled.section`
  ${fontScope}
  box-sizing: border-box;
  border: 1px solid ${colors.border};
  border-radius: ${radius.card};
  background: ${colors.white};
`

export const FieldsGrid = styled.div<{ $padding: string }>`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  padding: ${({ $padding }) => $padding};
`

export const Span2 = styled.div`
  grid-column: span 2;
  min-width: 0;
`

export const Strip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 22px 24px;
  border-top: 1px solid ${colors.border};
`

export const StripRow = styled.div`
  display: flex;
  align-items: center;
  gap: 19px;
`

export const VerticalDivider = styled.span`
  align-self: stretch;
  width: 1px;
  background: ${colors.border};
`

export const HorizontalDivider = styled.span`
  height: 1px;
  background: ${colors.border};
`

export const CourtesyGroup = styled.div`
  display: flex;
  flex: 1 0 0;
  align-items: center;
  gap: 8px;
  min-width: 0;
`

export const InlineLabel = styled.span`
  ${fieldLabel}
  white-space: nowrap;
`

export const CheckboxCell = styled.div`
  flex: 1 0 0;
  min-width: 0;
`

export const PeriodError = styled.p`
  margin: 0;
  padding: 0 24px 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: ${colors.primaryStrong};
`

export const MobileBar = styled.div`
  ${fontScope}
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`

export const FiltersButton = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 16px;
  border: 1px solid ${colors.border};
  border-radius: 22px;
  background: ${colors.white};
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  color: ${colors.ink800};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`

export const Counter = styled.span`
  min-width: 20px;
  height: 20px;
  box-sizing: border-box;
  padding: 0 6px;
  border-radius: 10px;
  background: ${colors.primary};
  font-size: 11px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  color: ${colors.white};
`

export const MobileSummary = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

export const SummaryText = styled.span<{ $muted?: boolean }>`
  overflow: hidden;
  font-size: 12px;
  font-weight: ${({ $muted }) => ($muted ? 400 : 600)};
  line-height: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ $muted }) => ($muted ? colors.ink500 : colors.ink800)};
`

export const SheetContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const SheetSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 20px;
  border-top: 1px solid ${colors.border};
`

export const SheetButton = styled.button<{ $primary?: boolean }>`
  flex: 1 1 0;
  height: 44px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  border: 0.8px solid ${({ $primary }) => ($primary ? colors.primary : colors.border)};
  background: ${({ $primary }) => ($primary ? colors.primary : colors.white)};
  color: ${({ $primary }) => ($primary ? colors.white : colors.ink800)};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`

export const MobileTitle = styled.h2`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${colors.ink800};
`

export const MobileStack = styled.div<{ $gap: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap};
`

export const MobileLabel = styled.span`
  ${fieldLabel}
  line-height: normal;
  letter-spacing: 0;
`

export const MobilePeriodError = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: ${colors.primaryStrong};
`
